// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"UpdateTextInput_inputContainer__2XnFN","categoryInput":"UpdateTextInput_categoryInput__2O9uF","categoryLabel":"UpdateTextInput_categoryLabel__8KFaI"};